import React, { useEffect } from 'react'

import {
  Col,
  FormRow,
} from '../../../../../../../../1stlog-ui/src/components/Bootstrap'
import {
  FeedbackBadge,
  useField,
} from '../../../../../../../../1stlog-ui/src/components/Field'

const validate = (v) => (v ? true : undefined)

const ForbiddenByLaw = (props) => {
  const {} = props

  const transportForbiddenByLaw = useField('transportForbiddenByLaw')

  const {
    input: {
      value: isTransportForbiddenByLaw,
      onChange: setIsTransportForbiddenByLaw,
    },
    meta,
  } = useField('validation.isTransportForbiddenByLaw', {
    raw: true,
    validate,
    subscribeAll: true,
  })

  useEffect(() => {
    setIsTransportForbiddenByLaw(transportForbiddenByLaw)
  }, [transportForbiddenByLaw])

  return isTransportForbiddenByLaw ? (
    <FormRow>
      <Col>
        <FeedbackBadge meta={meta}>
          {i18n.t('error_forbidden_by_law', 'Gesetzlich verboten')}
        </FeedbackBadge>
      </Col>
    </FormRow>
  ) : (
    <></>
  )
}

export default ForbiddenByLaw
